var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgModuleCrm(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99997 9.5L14 9H27.5C29 9 31 10.5 32 11.5C32.8 12.3 32.3333 15.5 32 17L23 21H21V18H15V21H14C11 20.5 4.69997 18.7 3.49997 15.5C2.29997 12.3 4.66663 10.1667 5.99997 9.5Z",
    fill: "#D6D6FA",
    stroke: "#D6D6FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 33H23.9999C30.0299 33 31.1099 30.585 31.4249 27.645L32.5499 15.645C32.9549 11.985 31.9049 9 25.4999 9H10.4999C4.09486 9 3.04486 11.985 3.44986 15.645L4.57486 27.645C4.88986 30.585 5.96986 33 11.9999 33Z",
    stroke: "#6467EF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9V7.8C12 5.145 12 3 16.8 3H19.2C24 3 24 5.145 24 7.8V9",
    stroke: "#6467EF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 19.5V21C21 21.015 21 21.015 21 21.03C21 22.665 20.985 24 18 24C15.03 24 15 22.68 15 21.045V19.5C15 18 15 18 16.5 18H19.5C21 18 21 18 21 19.5Z",
    stroke: "#6467EF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.475 16.5C29.01 19.02 25.05 20.52 21 21.03",
    stroke: "#6467EF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93005 16.905C7.30505 19.215 11.1151 20.61 15.0001 21.045",
    stroke: "#6467EF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModuleCrm);
export default __webpack_public_path__ + "static/media/module-crm.f884da7d.svg";
export { ForwardRef as ReactComponent };